import {FC} from 'react'
import {TimeSlot} from "../../types";
import CheckBox from "../common/Checkbox/Checkbox";
import {settings} from "../../constants/global";

interface Props {
    booking:Booking,
    setBooking:Function
}

const Rental: FC<Props> = ({booking, setBooking}) => {
    const handleCheckBox = () => {
        if(booking.loan_car_mercedes) {
            booking.loan_car_mercedes = false
        }else {
            booking.loan_car_mercedes = true
        }
        booking.calendar_carousel.index++
        booking.calendar_carousel.steps[2].active = true
        booking.loan_car = 'no'
        booking.submission.reload = true
        setBooking({
            ...booking,
        })
    }

    return (
        <>
            {settings.rental.mercedes.active && booking.car.model.startsWith("EQ") && (
                <>
                    <div className={"submissions"}>
                        <h2>Hyrbil</h2>
                        <div className={`submissions_option ${booking.loan_car_mercedes === true ? "active" : ""}`} onClick={() => handleCheckBox()}>
                            <h4>{settings.rental.mercedes.checkbox}</h4>
                        </div>
                    </div>
                </>
            )}
        </>
    )
};

export default Rental
